module.exports = __webpack_public_path__ + "img/agengtmsg.ad2a7931.png";